import React from 'react';
import AboutUs from './about-us';
import Feature from './Feature';
// import Testimonial from './Testimonial';
import APICards from './APICards';
import { Navbar } from './Navbar/Navbar';
import { Footer } from './Footer';
import ComingSoonAPI from './ComingSoonAPI';
import OurTeamSection from './OurTeamSection';

import HeroSection from './HeroSection'
import TopHeading from './TopHeading'

function LandingRoute() {
  return (
    <>
      <div className='bg-backgroundPaper'>
        <Navbar />
        <TopHeading />
        <HeroSection />
        {/* <Header /> */}
        <Feature />
        <APICards />
        <ComingSoonAPI />
        <AboutUs />
        <OurTeamSection />
        {/* <Testimonial /> */}
        <Footer />
      </div>
    </>
  );
}

export default LandingRoute;
